import { memo, useEffect } from 'react';

import { recordPageGA } from '../../../modules/ga';

import { Collapse } from 'antd';
import { COMPETITION_STATUS } from '../../../modules/competition';
import { disconnectSocket, joinRoom, sendMessageToRoom } from '../../../modules/websocket';
import DeleteButtonWithConfirm from '../../Utils/DeleteButtonWithConfirm';
import CompetitionStage1 from './CompetitionStage1';
import CompetitionStage2 from './CompetitionStage2';
import CompetitionStage3 from './CompetitionStage3';
import CompetitionStage4 from './CompetitionStage4';

const { Panel } = Collapse;

let intervalId = null;


const CompetitionDetails = ({ lang, theCompetition, theClass, loadCompetition, onDelete, onUpdate, onExpireTime }) => {
    // Registro en Google Analytics
    useEffect(() => {
        recordPageGA('/competition-details');

        if (theCompetition) {
            joinRoom(`mt-${theCompetition.id}`);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
            disconnectSocket();
        };

    }, []);

    useEffect(() => {
        
    }, [theCompetition]);


    const handleChangeCompetitionStatus = (toStatus) => {
        onUpdate({ status: toStatus });
        sendMessageToRoom({ status: toStatus }, `mt-${theCompetition.id}`);
    }

    const handleNextExercise = () => {
        const currentExercise = theCompetition.currentExercise || 0;
        const nextExercise = currentExercise + 1;
        onUpdate({ currentExercise: nextExercise });
    }

    const handleExpireTime = () => {
        const currentExercise = theCompetition.currentExercise || 0;
        if (currentExercise) onExpireTime(`e${currentExercise}`);
    }

    // console.log('CompetitionDetails theCompetition: ', theCompetition, 'theClass:', theClass);

    if (theCompetition && theClass) {

        return (
            <section className="class-details competition">
                {!theCompetition.status || theCompetition.status == COMPETITION_STATUS.INIT ? <CompetitionStage1 lang={lang} theCompetition={theCompetition} theClass={theClass} handleOpenCompetition={() => handleChangeCompetitionStatus(COMPETITION_STATUS.OPENED)} /> : null}

                {theCompetition.status == COMPETITION_STATUS.OPENED ? <CompetitionStage2 lang={lang} theCompetition={theCompetition} theClass={theClass} handleStartCompetition={() => handleChangeCompetitionStatus(COMPETITION_STATUS.PLAYING)} /> : null}

                {theCompetition.status == COMPETITION_STATUS.PLAYING ? <CompetitionStage3 lang={lang} theCompetition={theCompetition} handleFinishCompetition={() => handleChangeCompetitionStatus(COMPETITION_STATUS.FINISHED)} handleNextExercise={handleNextExercise} handleExpireTime={handleExpireTime} /> : null}
                {theCompetition.status == COMPETITION_STATUS.FINISHED ? <CompetitionStage4 lang={lang} theCompetition={theCompetition} /> : null}
                <br />
                <div>
                    {(!theCompetition.status || theCompetition.status == COMPETITION_STATUS.INIT) ? <DeleteButtonWithConfirm
                        lang={lang}
                        text={'deleteCompetition'}
                        message={'deletecompetitionwilleliminatestudentsaccess'}
                        onDelete={() => {
                            // console.log('Acción de borrar ejecutada');
                            onDelete(theCompetition.teacher, theCompetition.id);
                        }}
                    /> : null}
                </div>

            </section>
        );
    } else return null;
};

export default memo(CompetitionDetails);